import { defineMessages } from 'react-intl-next';

export const messages: {
	airtable: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	asana: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	atlas: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	atlassianWebCrawler: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	bitbucket: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	compass: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	confluence: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	dropbox: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	figma: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	github: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	gmail: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	goal: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	goals: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	googleCalendar: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	googleDrive: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	jira: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	jiraProductDiscovery: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	jiraServiceManagement: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	loom: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	microsoftSharepoint: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	miro: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	notion: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	oneDrive: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	outlookCalendar: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	project: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	projects: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	sharepoint: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	slack: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	tag: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	tags: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	teams: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	trello: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	webPage: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	webPages: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	zendesk: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	atlas: {
		id: 'dynamic-cards-search-page.products.atlas',
		defaultMessage: 'Atlas',
		description:
			'The text is shown as a filter tab and sidebar option on the full-page search screen so users can filter results by Atlas. It also appears as metadata next to results and as the accessible label for the Atlas icon.',
	},
	webPage: {
		id: 'dynamic-cards-search-page.products.custom-website',
		defaultMessage: 'Web page',
		description:
			'The text is shown as a drop-down item in the "Build Dynamic Cards" modal when the user clicks "View current filters" in a dynamic cards configuration panel. It labels the option for searching crawled web pages.',
	},
	webPages: {
		id: 'dynamic-cards-search-page.products.custom-websites',
		defaultMessage: 'Web pages',
		description:
			'The text is shown as a drop-down item (plural form) in the "Build Dynamic Cards" modal when the user clicks "View current filters" in a dynamic cards configuration panel. It labels the option for searching crawled web pages.',
	},
	project: {
		id: 'dynamic-cards-search-page.nouns.project',
		defaultMessage: 'Project',
		description:
			'The text is shown as a drop-down item in the "Build Dynamic Cards" modal when the user clicks "View current filters" in a dynamic cards configuration panel. It labels the Atlas noun filter option for projects.',
	},
	projects: {
		id: 'dynamic-cards-search-page.nouns.projects',
		defaultMessage: 'Projects',
		description:
			'The text is shown as a drop-down item (plural form) in the "Build Dynamic Cards" modal when the user clicks "View current filters" in a dynamic cards configuration panel. It labels the Atlas noun filter option for projects.',
	},
	goal: {
		id: 'dynamic-cards-search-page.nouns.goal',
		defaultMessage: 'Goal',
		description:
			'The text is shown as a drop-down item in the "Build Dynamic Cards" modal when the user clicks "View current filters" in a dynamic cards configuration panel. It labels the Atlas noun filter option for goals.',
	},
	goals: {
		id: 'dynamic-cards-search-page.nouns.goals',
		defaultMessage: 'Goals',
		description:
			'The text is shown as a drop-down item (plural form) in the "Build Dynamic Cards" modal when the user clicks "View current filters" in a dynamic cards configuration panel. It labels the Atlas noun filter option for goals.',
	},
	tag: {
		id: 'dynamic-cards-search-page.nouns.tag',
		defaultMessage: 'Tag',
		description:
			'The text is shown as a drop-down item in the "Build Dynamic Cards" modal when the user clicks "View current filters" in a dynamic cards configuration panel. It labels the Atlas noun filter option for tags.',
	},
	tags: {
		id: 'dynamic-cards-search-page.nouns.tags',
		defaultMessage: 'Tags',
		description:
			'The text is shown as a drop-down item (plural form) in the "Build Dynamic Cards" modal when the user clicks "View current filters" in a dynamic cards configuration panel. It labels the Atlas noun filter option for tags.',
	},
	sharepoint: {
		id: 'dynamic-cards-search-page.products.sharepoint',
		defaultMessage: 'SharePoint',
		description:
			'The text is used as the accessible label (aria-label) for the Microsoft SharePoint icon shown next to search results on the full-page search screen, so screen reader users know which product the result is from.',
	},
	atlassianWebCrawler: {
		id: 'dynamic-cards-search-page.products.atlassian-web-crawler',
		defaultMessage: 'Atlassian Web Crawler',
		description:
			'The text is used as the accessible label (aria-label) for the web crawler icon shown next to search results on the full-page search screen, so screen reader users know the result is from a crawled web page.',
	},
	confluence: {
		id: 'dynamic-cards-search-page.products.confluence',
		defaultMessage: 'Confluence',
		description:
			'The text is shown as a filter tab and sidebar option on the full-page search screen so users can filter results by Confluence. It also appears as metadata next to results and as the accessible label for the Confluence icon.',
	},
	jira: {
		id: 'dynamic-cards-search-page.products.jira',
		defaultMessage: 'Jira',
		description:
			'The text is shown as a filter tab and sidebar option on the full-page search screen so users can filter results by Jira. It also appears as metadata next to results and as the accessible label for the Jira icon.',
	},
	jiraProductDiscovery: {
		id: 'dynamic-cards-search-page.products.jira-product-discovery',
		defaultMessage: 'Jira Product Discovery',
		description:
			'The text is shown as a filter tab and sidebar option on the full-page search screen so users can filter results by Jira Product Discovery and identify which results came from that product.',
	},
	jiraServiceManagement: {
		id: 'dynamic-cards-search-page.products.jira-service-management',
		defaultMessage: 'Jira Service Management',
		description:
			'The text is shown as a filter tab and sidebar option on the full-page search screen so users can filter results by Jira Service Management and identify which results came from that product.',
	},
	bitbucket: {
		id: 'dynamic-cards-search-page.products.bitbucket',
		defaultMessage: 'Bitbucket',
		description:
			'The text is shown as a filter tab and sidebar option on the full-page search screen so users can filter results by Bitbucket and identify which results came from that product.',
	},
	trello: {
		id: 'dynamic-cards-search-page.products.trello',
		defaultMessage: 'Trello',
		description:
			'The text is shown as a filter tab and sidebar option on the full-page search screen so users can filter results by Trello and identify which results came from that product.',
	},
	compass: {
		id: 'dynamic-cards-search-page.products.compass',
		defaultMessage: 'Compass',
		description:
			'The text is shown as a filter tab and sidebar option on the full-page search screen so users can filter results by Compass and identify which results came from that product.',
	},
	googleDrive: {
		id: 'dynamic-cards-search-page.products.google-drive',
		defaultMessage: 'Google Drive',
		description:
			'The text is shown as a filter tab and sidebar option on the full-page search screen so users can filter results by Google Drive. It also appears as metadata next to results and as the accessible label for the Google Drive icon.',
	},
	teams: {
		id: 'dynamic-cards-search-page.products.teams',
		defaultMessage: 'Teams',
		description:
			'The text is shown as a filter tab and sidebar option on the full-page search screen so users can filter results by Microsoft Teams. It also appears as metadata next to results and as the accessible label for the Teams icon.',
	},
	loom: {
		id: 'dynamic-cards-search-page.products.loom',
		defaultMessage: 'Loom',
		description:
			'The text is shown as a filter tab and sidebar option on the full-page search screen so users can filter results by Loom. It also appears as metadata next to results and as the accessible label for the Loom icon.',
	},
	oneDrive: {
		id: 'dynamic-cards-search-page.products.onedrive',
		defaultMessage: 'OneDrive',
		description:
			'The text is shown as a filter tab and sidebar option on the full-page search screen so users can filter results by OneDrive. It also appears as metadata next to results and as the accessible label for the OneDrive icon.',
	},
	slack: {
		id: 'dynamic-cards-search-page.products.slack',
		defaultMessage: 'Slack',
		description:
			'The text is shown as a filter tab and sidebar option on the full-page search screen so users can filter results by Slack. It also appears as metadata next to results and as the accessible label for the Slack icon.',
	},
	github: {
		id: 'dynamic-cards-search-page.products.github',
		defaultMessage: 'GitHub',
		description:
			'The text is shown as a filter tab and sidebar option on the full-page search screen so users can filter results by GitHub. It also appears as metadata next to results and as the accessible label for the GitHub icon.',
	},
	figma: {
		id: 'dynamic-cards-search-page.products.figma',
		defaultMessage: 'Figma',
		description:
			'The text is shown as a filter tab and sidebar option on the full-page search screen so users can filter results by Figma. It also appears as metadata next to results and as the accessible label for the Figma icon.',
	},
	dropbox: {
		id: 'dynamic-cards-search-page.products.dropbox',
		defaultMessage: 'Dropbox',
		description:
			'The text is shown as a filter tab and sidebar option on the full-page search screen so users can filter results by Dropbox. It also appears as metadata next to results and as the accessible label for the Dropbox icon.',
	},
	googleCalendar: {
		id: 'dynamic-cards-search-page.products.google-calendar',
		defaultMessage: 'Google Calendar',
		description:
			'The text is shown as a filter tab and sidebar option on the full-page search screen so users can filter results by Google Calendar and identify which results came from that product.',
	},
	gmail: {
		id: 'dynamic-cards-search-page.products.gmail',
		defaultMessage: 'Gmail',
		description:
			'The text is shown as a filter tab and sidebar option on the full-page search screen so users can filter results by Gmail and identify which results came from that product.',
	},
	outlookCalendar: {
		id: 'dynamic-cards-search-page.products.outlook-calendar',
		defaultMessage: 'Outlook Calendar',
		description:
			'The text is shown as a filter tab and sidebar option on the full-page search screen so users can filter results by Outlook Calendar and identify which results came from that product.',
	},
	airtable: {
		id: 'dynamic-cards-search-page.products.airtable',
		defaultMessage: 'Airtable',
		description:
			'The text is shown as a filter tab and sidebar option on the full-page search screen so users can filter results by Airtable. It also appears as metadata next to results and as the accessible label for the Airtable icon.',
	},
	asana: {
		id: 'dynamic-cards-search-page.products.asana',
		defaultMessage: 'Asana',
		description:
			'The text is shown as a filter tab and sidebar option on the full-page search screen so users can filter results by Asana and identify which results came from that product.',
	},
	zendesk: {
		id: 'dynamic-cards-search-page.products.zendesk',
		defaultMessage: 'Zendesk',
		description:
			'The text is shown as a filter tab and sidebar option on the full-page search screen so users can filter results by Zendesk and identify which results came from that product.',
	},
	notion: {
		id: 'dynamic-cards-search-page.products.notion',
		defaultMessage: 'Notion',
		description:
			'The text is shown as a filter tab and sidebar option on the full-page search screen so users can filter results by Notion. It also appears as metadata next to results and as the accessible label for the Notion icon.',
	},
	miro: {
		id: 'dynamic-cards-search-page.products.miro',
		defaultMessage: 'Miro',
		description:
			'The text is shown as a filter tab and sidebar option on the full-page search screen so users can filter results by Miro. It also appears as metadata next to results and as the accessible label for the Miro icon.',
	},
	microsoftSharepoint: {
		id: 'dynamic-cards-search-page.products.microsoft-sharepoint',
		defaultMessage: 'Microsoft SharePoint',
		description:
			'The text is shown as a filter tab and sidebar option on the full-page search screen so users can filter results by Microsoft SharePoint and identify which results came from that product.',
	},
});
